import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloTipoProduto } from "../models/tipoProduto";
import { Repositorio } from "./repositorio";

export class RepositorioTipoProduto extends Repositorio<ModeloTipoProduto> {
  constructor() {
    super(ConstanteGlobal.TIPO_PRODUTO);
  }
}
